import { chakra, Text, VStack, HStack, Icon, Box } from "@chakra-ui/react";
import {
  Reorder,
  useMotionValue,
  useDragControls,
  DragControls,
  motion,
  LayoutGroup,
} from "framer-motion";
import { FiMove } from "react-icons/fi";
import { useCallback, useRef } from "react";
import useMeasure from "react-use-measure";

const Item = chakra(Reorder.Item);
const MotionBox = motion(Box);

const DraggableItem = ({
  children,
  id,
  isDisabled,
}: {
  children: React.ReactNode;
  id: string;
  isDisabled?: boolean;
}) => {
  const dragControls = useDragControls();
  const y = useMotionValue(0);
  const isDragging = useRef(false);
  const [ref, bounds] = useMeasure({
    debounce: 100,
  });

  const handleMouseDownReorder = useCallback(
    (e: React.PointerEvent, item: any, dc: DragControls) => {
      e.preventDefault();
      e.stopPropagation();
      isDragging.current = true;
      dc.start(e);
    },
    []
  );

  const handleDragEnd = useCallback(() => {
    isDragging.current = false;
  }, []);

  return (
    <Item
      userSelect={"none"}
      key={id}
      id={id}
      value={id}
      style={{
        y,
        backgroundColor: "white",
        position: "relative",
      }}
      borderBottomWidth={1}
      borderBottomColor={"gray.100"}
      dragControls={isDisabled ? undefined : dragControls}
      dragListener={!isDisabled}
      onDragEnd={handleDragEnd}
      cursor="grab"
      _active={{ cursor: "grabbing" }}
      onPointerDown={(e) => {
        if (!isDragging.current) {
          handleMouseDownReorder(e, {}, dragControls);
        }
      }}
      initial={false}
      animate={{ height: bounds.height }}
    >
      <VStack ref={ref} w="full" display="flex" flexDirection="column">
        {children}
      </VStack>
    </Item>
  );
};

export default DraggableItem;
